module.exports = __webpack_public_path__ + "img/sunrise.97fdadc9.svg";